export type PositionResponse = {
  "db/id"?: string;
  "position/display-name": string;
  "credentialRequired?"?: boolean;
  "position/long-term-pay-rate"?: string;
  "position/pay-rate"?: string;
  "position/payrate-type"?: string;
  "position/pay-configs"?: PositionPayConfigResponse[];
  payConfigs?: PositionPayConfigResponse[];
  payrateType?: string;
  "position/sub-name"?: string;
};

export type PositionRateType = "hourly" | "daily";

export type PositionPayConfigResponse = {
  "pay-config/unit"?: "hour" | "day" | "half-day" | string;
  unit?: "hour" | "day" | "half-day" | string;
};

export class PositionModel {
  private position;

  constructor(position: PositionResponse) {
    this.position = position;
  }

  get id(): string {
    return this.position?.["db/id"] || "";
  }

  get displayName() {
    return this.position?.["position/display-name"] || "";
  }

  get credsRequired() {
    return this.position?.["credentialRequired?"] || false;
  }

  get longTermPayRate() {
    return this.position?.["position/long-term-pay-rate"] || "";
  }

  get payRate() {
    return this.position?.["position/pay-rate"] || "";
  }

  get payrateType() {
    return this.position?.payrateType;
  }

  get payConfigUnits() {
    const payConfigs = this.position?.["position/pay-configs"] || this.position?.payConfigs || [];

    return payConfigs.map((payConfig) => payConfig["pay-config/unit"] || payConfig.unit);
  }

  get subName() {
    return this.position?.["position/sub-name"] || ";";
  }
}
